import { render, staticRenderFns } from "./process.vue?vue&type=template&id=5112da3b&scoped=true&"
import script from "./process.vue?vue&type=script&lang=js&"
export * from "./process.vue?vue&type=script&lang=js&"
import style0 from "./process.vue?vue&type=style&index=0&id=5112da3b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5112da3b",
  null
  
)

export default component.exports